<fui-numeric-control [disabled]="isReadonly" [label]="label" [placeholder]="placeholder" [attr.id]="elementId"
                     [(ngModel)]="value" [notation]="notation" [control]="formControl" [decimals]="decimals"
                     [showClear]="showClear">
</fui-numeric-control>
